import React from "react";
import styled from "styled-components";

// importing slick for carousel
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import { Link } from "react-router-dom";

const ImgSlider = () => {
  const settings = {
    dots: true,
    Infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
  };

  return (
    <Carousel {...settings}>
      <Wrap>
        <Link to="/detail/REMDMGctHfTwMJXd1Ook">
          <img src="/images/slider-badging.jpg" alt="" />
        </Link>
      </Wrap>
      <Wrap>
        <Link to="/detail/aBkDnbog5yoYTTSIDrlM">
          <img src="/images/slider-scale.jpg" alt="" />
        </Link>
      </Wrap>
      <Wrap>
        <Link to="/detail/lsEgUKcJVWmUipKJ16QD">
          <img src="/images/slider-badag.jpg" alt="" />
        </Link>
      </Wrap>
      <Wrap>
        <Link to="/detail/e8MBAheXk8paesNYfreJ">
          <img src="/images/slider-scales.jpg" alt="" />
        </Link>
      </Wrap>
    </Carousel>
  );
};

const Carousel = styled(Slider)`
  margin-top: 20px;

  /* for side buttons of carousel */
  & > button {
    opacity: 0;
    height: 100%;
    width: 5vw;
    z-index: 1;

    &:hover {
      opacity: 0.6;
      transition: opacity 0.3s ease 0s;
    }
  }

  ul li button {
    &:before {
      font-size: 10px;
      color: rgb(150, 158, 171);
    }
  }

  /* for dots under carousel */
  li.slick-active button:before {
    color: white;
  }

  /* for displaying next and before slide as well */
  .slick-list {
    overflow: initial;
  }

  .slick-prev {
    left: -75px;
  }

  .slick-next {
    right: -75px;
  }
`;

// actual image components of carousel
const Wrap = styled.div`
  border-radius: 4px;
  cursor: pointer;
  position: relative;

  a {
    border-radius: 4px;
    box-shadow: rgba(0 0 0 / 69%) 0px 26px 30px -10px,
      rgb(0 0 0/73%) 0px 26px 30px -10px;
    cursor: pointer;
    display: block;
    position: relative;
    padding: 4px;

    img {
      width: 100%;
      height: 100%;
      border-radius: 4px;
    }

    &:hover {
      padding: 0;
      border: 4px solid rgba(249, 249, 249, 0.8);
      transition-duration: 80ms;
    }
  }
`;

export default ImgSlider;
